var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import { UserModel, RoleUserModel } from "../../../../../models/manage/user.models";
import { ArrayUtils } from "../../../../../utilities/arrays";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { RequestClient } from "../../../../../services/basics/request-client.service";
import { StringUtilities } from "../../../../../utilities/strings";
var ManageUser = /** @class */ (function () {
    function ManageUser(requestClient, userClaimsService) {
        this.requestClient = requestClient;
        this.userClaimsService = userClaimsService;
        this.roleClientId = 0;
        this._password = undefined;
        this.confirmPassword = undefined;
        this.defaults = {
            password: "(^*#$&!@)", // some random string that is not quite common
        };
        this.setAutomatically = null;
        this.canEditUser = true;
        this.clientId = -1;
        this.hasClientRole = false;
        this.showClientRequiredError = false;
        this.canEditUser = this.userClaimsService.hasPermission(Claims.CanUpdateUsers);
    }
    Object.defineProperty(ManageUser.prototype, "newPassword", {
        get: function () {
            return this._password;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "defaultMockPassword", {
        get: function () {
            return this.defaults.password;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "getUpdatedPassword", {
        get: function () {
            return this.isPasswordUpdated ? this._password : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "isPasswordUpdated", {
        get: function () {
            return this._password !== this.defaultMockPassword;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "password", {
        set: function (val) {
            var _this = this;
            if (val === null) {
                this.setAutomatically = null;
                this.confirmPassword = undefined;
            }
            else if (this.user) {
                if (val === this.defaultMockPassword && this.setAutomatically === null) {
                    setTimeout(function () {
                        _this.setAutomatically = true;
                        _this.confirmPassword = undefined;
                    });
                }
                else if (this.setAutomatically === true) {
                    setTimeout(function () {
                        _this.setAutomatically = false;
                        if (val.length === _this.defaultMockPassword.length + 1) {
                            _this.passVM.clearField();
                            for (var i = 0; i < val.length; i++) {
                                if (i >= _this.defaultMockPassword.length || _this.defaultMockPassword.charAt(i) !== val.charAt(i)) {
                                    val = val.charAt(i);
                                    break;
                                }
                            }
                            _this.passVM.value = val;
                        }
                    });
                }
            }
            this._password = val;
        },
        enumerable: false,
        configurable: true
    });
    ManageUser.prototype.userHasChanged = function (newValue, oldValue) {
        var _this = this;
        this.password = null;
        this.confirmPassword = undefined;
        if (newValue && newValue.userId > 0 && newValue.passwordHash) {
            this.passVM.value = this.defaultMockPassword;
        }
        else {
            this.passVM.value = null;
        }
        if (newValue && this.user.roleUsers) {
            if (this.user.userId === 0) {
                this.user.passwordHash = null;
            }
            if (this.user) {
                this.hasClientRole = this.user.roleUsers.some(function (x) { return x.role && (StringUtilities.startsWith(x.role.roleName, "Client")); });
                this.clientId = -1;
                if (this.hasClientRole && this.clientAssociationEnabled) {
                    //can't find ClientUsers endpoint anywhere, get<{items: UserModel}> is wrong here because UserModel
                    //doesn't have clientId. The call doesn't seem to be used anywhere. setting it to items: any for now
                    this.requestClient.get("ClientUsers/GetClientByUserId", { id: newValue.userId }).then(function (x) {
                        if (x && x.items) {
                            var client = x.items[0];
                            if (client) {
                                _this.clientId = client.clientId;
                            }
                            else {
                                _this.clientId = null;
                            }
                        }
                    }, function (e) { });
                }
            }
        }
    };
    ManageUser.prototype.attached = function () {
        if (this.user && this.user.userId > 0 && this.user.passwordHash) {
            this.passVM.value = this.defaultMockPassword;
        }
        this._password = null;
    };
    ManageUser.prototype.removeRole = function (item) {
        var _this = this;
        ArrayUtils.remove(this.user.roleUsers, item);
        this.hasClientRole = this.user.roleUsers.some(function (x) { return x.roleId === _this.roleClientId; });
    };
    ManageUser.prototype.addRole = function () {
        this.user.roleUsers.push(new RoleUserModel(this.user));
    };
    ManageUser.prototype.roleChanged = function ($event, $index) {
        var _this = this;
        var roleClientName;
        if ($event.detail && $event.detail.item) {
            roleClientName = $event.detail.item.name;
        }
        else if ($event.detail && $event.detail.newValue) {
            roleClientName = $event.detail.newValue.name;
        }
        else {
            return;
        }
        if (roleClientName.startsWith("Client")) {
            this.roleClientId = $event.detail.item.id;
            this.hasClientRole = true;
        }
        else {
            this.hasClientRole = this.user.roleUsers.some(function (x) { return x.roleId === _this.roleClientId; });
            if (this.hasClientRole && (this.user.roleUsers[$index].roleId === this.roleClientId)) {
                this.hasClientRole = false;
            }
        }
        if (!this.hasClientRole) {
            this.clientId = -1;
        }
    };
    ManageUser.prototype.addContactNumber = function () {
        var userContactNumber = {
            userId: this.user.userId,
            phoneNumber: null,
            phoneNumberType: -1,
            phoneSequence: 0,
            phoneID: 0
        };
        this.user.userPhoneNumbers.push(userContactNumber);
    };
    ManageUser.prototype.removeContactNumber = function (item) {
        ArrayUtils.remove(this.user.userPhoneNumbers, item);
    };
    Object.defineProperty(ManageUser.prototype, "isConfirmPasswordMatched", {
        get: function () {
            if (this.setAutomatically)
                return true;
            if (this.newPassword === this.confirmPassword)
                return true;
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ManageUser.prototype, "validateUpdatedPassword", {
        get: function () {
            // password was set automatically and its not changed manually by the user then no issue
            if (this.setAutomatically)
                return true;
            // if password was changed by the user and the new password matches the default password, 
            // then show a validation error to change the password
            if (this.newPassword === this.defaultMockPassword)
                return false;
            if (this.newPassword === "")
                return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ManageUser.prototype, "clientId", void 0);
    __decorate([
        bindable,
        __metadata("design:type", UserModel)
    ], ManageUser.prototype, "user", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ManageUser.prototype, "clientAssociationEnabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ManageUser.prototype, "hasClientRole", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ManageUser.prototype, "showClientRequiredError", void 0);
    ManageUser = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [RequestClient, UserClaimsService])
    ], ManageUser);
    return ManageUser;
}());
export { ManageUser };
